import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import React from 'react'

import './assets/styles/main.css'

import App from './components/app/App'
import store from './app/store'

createRoot(document.getElementById('root')).render(
  <>
    <Provider store={store}>
      <App />
    </Provider>
  </>,
)
